import { ClientFormData } from "../types";

/**
 * Strips Apollo `__typename` from a ClientFormData payload before sending it
 * to a mutation. Apollo cache decorates every queried object with `__typename`,
 * which the backend's `forbidUnknownValues: true` validator rejects.
 *
 * Optionally overrides the email or phoneNumber — used by the email/phone
 * verification flows where the form's current value (the new email) needs to
 * be persisted only AFTER the verification modal succeeds.
 */
export const cleanFormDataInput = (
    formData: ClientFormData,
    overrides?: { email?: string; phoneNumber?: string }
) => ({
    ...formData,
    ...(overrides?.email !== undefined ? { email: overrides.email } : {}),
    ...(overrides?.phoneNumber !== undefined ? { phoneNumber: overrides.phoneNumber } : {}),
    paymentReceivingDetails: {
        ...formData.paymentReceivingDetails,
        cryptoWallets: formData.paymentReceivingDetails.cryptoWallets.map((wallet) => ({
            walletAddress: wallet.walletAddress,
            network: wallet.network,
            memo: wallet.memo,
        })),
        bankAccount: formData.paymentReceivingDetails.bankAccount
            ? {
                  accountName: formData.paymentReceivingDetails.bankAccount.accountName,
                  bsb: formData.paymentReceivingDetails.bankAccount.bsb,
                  accountNumber: formData.paymentReceivingDetails.bankAccount.accountNumber,
                  bankName: formData.paymentReceivingDetails.bankAccount.bankName,
                  swiftCode: formData.paymentReceivingDetails.bankAccount.swiftCode,
              }
            : undefined,
        stripeConnect: formData.paymentReceivingDetails.stripeConnect
            ? {
                  stripeAccountId: formData.paymentReceivingDetails.stripeConnect.stripeAccountId,
                  accountVerified: formData.paymentReceivingDetails.stripeConnect.accountVerified,
                  verifiedAt: formData.paymentReceivingDetails.stripeConnect.verifiedAt,
              }
            : undefined,
        cryptoDiscountPercentage: formData.paymentReceivingDetails.cryptoDiscountPercentage,
    },
});
